<template>
  <v-card>
    <v-data-table :headers="headers_tipi" :items="items_tipi">
      <template v-slot:top>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Tipi Segnalazione
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <!-- Bottone di modifica -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="addTipo" small v-bind="attrs" v-on="on">
                <v-icon color="primary"> mdi-plus </v-icon>
              </v-btn>
            </template>
            <span>Aggiungi Tipo Segnalazione</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <!-- Bottone per tornare indietro -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="clickBack" small v-bind="attrs" v-on="on">
                <v-icon color="error"> mdi-keyboard-backspace </v-icon>
              </v-btn>
            </template>
            <span>Indietro</span>
          </v-tooltip>
        </v-toolbar>
      </template>
      <!-- Bottone di modifica -->
      <template v-slot:[`item.modifica`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="mr-5"
              @click="modificaTipoSegnalazione(item)"
              small
              v-bind="attrs"
              v-on="on"
            >
              <v-icon color="primary"> mdi-pencil </v-icon>
            </v-btn>
          </template>
          <span>Modifica Dichiarazione</span>
        </v-tooltip>
      </template>

      <!-- Bottone di eliminazione -->
      <template v-slot:[`item.elimina`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="mr-5"
              @click="clickEliminaTipoSegnalazione(item)"
              small
              v-bind="attrs"
              v-on="on"
            >
              <v-icon color="error"> mdi-close </v-icon>
            </v-btn>
          </template>
          <span>Elimina Tipo Segnalazione</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <!-- Dialog di aggiunta / modifica -->
    <v-dialog v-model="dialog_modifica" max-width="800px">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Tipo Segnalazione
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="salvaModificaTipoSegnalazione"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="success">mdi-floppy</v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_modifica = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text style="overflow-y: auto">
          <v-container>
            <v-row align="center" justify="center">
              <v-col align="center" cols="12">
                <v-text-field
                  dense
                  hide-details
                  label="Descrizione"
                  outlined
                  v-model="tipo_segnalazione_sel.des"
                ></v-text-field>
              </v-col>
              <v-col align="center" cols="12">
                <v-text-field
                  dense
                  hide-details
                  label="Codice"
                  outlined
                  v-model="tipo_segnalazione_sel.cod"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>

      <!-- Overlay di caricamento per il salvataggio -->
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-dialog>

    <!-- Dialog di conferma eliminazione -->
    <v-dialog v-model="conferma_elimina" width="unset">
      <v-card style="max-width: 500px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Eliminazione </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <span style="color: rgb(0, 0, 0); font-size: 18px">
            Confermi di voler eliminare il tipo di segnalazione selezionato?
          </span>
          <v-divider class="my-5"></v-divider>
          <v-container>
            <v-row align="center" justify="center">
              <v-col class="my-0 py-0" justify="center" cols="12">
                <v-btn class="mr-5" @click="conferma_elimina = false" small>
                  <v-icon color="error"> mdi-close </v-icon>
                </v-btn>

                <v-btn @click="eliminaTipoSegnalazione" small>
                  <v-icon color="success"> mdi-check </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>

      <!-- Overlay di caricamento per l'eliminazione -->
      <v-overlay :value="overlay_cancellazione">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-dialog>

    <!-- Overlay di caricamento -->
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>
<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

class TipoSegnalazione {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] =
          arg[c.nome] != undefined
            ? c.complex === false
              ? arg[c.nome]
              : JSON.parse(JSON.stringify(arg[c.nome]))
            : c.default_val;
      });
    } else {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }

  // Metodo per resettare tutte le campi
  reset() {
    const campi = this.setCampi();

    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setCampi() {
    const campi = [
      { nome: "cod", default_val: "", complex: false },
      { nome: "des", default_val: "", complex: false },
      { nome: "id_tabella", default_val: -1, complex: false },
      { nome: "tipo", default_val: "TIPOLOGIA_SEGNALAZIONE", complex: false },
      { nome: "validita", default_val: 1, complex: false },
    ];

    return campi;
  }
}

export default {
  name: "TabellaTipiSegnalazione",
  components: { SnackbarQV },
  props: {},
  data() {
    return {
      // Variabili d'appoggio
      tipo_segnalazione_sel: new TipoSegnalazione(),

      // Modal
      conferma_elimina: false,
      dialog_modifica: false,
      overlay: false,
      overlay_cancellazione: false,

      // Array
      items_tipi: new Array(),
      headers_tipi: [
        {
          text: "Modifica",
          value: "modifica",
          sortable: false,
          width: "150px",
        },
        { text: "Nome Tipo Segnalazione", value: "des", sortable: false },
        { text: "Codice", value: "cod", sortable: false },
        { text: "Elimina", value: "elimina", sortable: false, width: "150px" },
      ],
    };
  },
  computed: {},
  watch: {
    variabile: {
      immediate: true,
      handler() {},
    },
  },
  methods: {
    addTipo() {
      this.tipo_segnalazione_sel = new TipoSegnalazione();
      this.dialog_modifica = true;
    },
    clickBack() {
      this.$emit("click_chiudi");
    },
    clickEliminaTipoSegnalazione(arg) {
      this.tipo_segnalazione_sel = new TipoSegnalazione(arg);
      this.conferma_elimina = true;
    },
    modificaTipoSegnalazione(arg) {
      this.tipo_segnalazione_sel = new TipoSegnalazione(arg);
      this.dialog_modifica = true;
    },
    eliminaTipoSegnalazione() {
      const obj_tmp = new TipoSegnalazione(this.tipo_segnalazione_sel);
      obj_tmp.validita = 0;

      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "settabelle",
          token: localStorage.user_token,
          tabella: [obj_tmp],
          id_utente: localStorage.id,
          assistenza: 0,
        },
      };

      this.overlay_cancellazione = true;

      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay_cancellazione = false;
          if (res.status === 200) {
            this.conferma_elimina = false;
            this.getTabelle();
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile aggiornare i dati."
            );
          }
        })
        .catch((e) => {
          this.overlay_cancellazione = false;
          console.error(e);
          this.$refs.SnackbarQV.print(
            "orange",
            "Errore di comunicazione col server, non è stato possibile aggiornare i dati."
          );
        });
    },
    getTabelle() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "gettabelle",
          token: localStorage.user_token,
          tipo: "TIPOLOGIA_SEGNALAZIONE",
        },
      };

      this.overlay = true;

      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            this.items_tipi = res.data;
            console.log(this.items_tipi);
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile aggiornare i dati."
            );
          }
        })
        .catch((e) => {
          this.overlay = false;
          console.error(e);
          this.$refs.SnackbarQV.print(
            "orange",
            "Errore di comunicazione col server, non è stato possibile aggiornare i dati."
          );
        });
    },
    salvaModificaTipoSegnalazione() {
      const obj_tmp = new TipoSegnalazione(this.tipo_segnalazione_sel);

      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "settabelle",
          token: localStorage.user_token,
          id_utente: localStorage.id,
          tabella: [obj_tmp],
          assistenza: 0,
        },
      };

      this.overlay = true;

      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            this.dialog_modifica = false;
            this.getTabelle();
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile aggiornare i dati."
            );
          }
        })
        .catch((e) => {
          this.overlay = false;
          console.error(e);
          this.$refs.SnackbarQV.print(
            "orange",
            "Errore di comunicazione col server, non è stato possibile aggiornare i dati."
          );
        });
    },
  },
  created() {},
  mounted() {
    this.getTabelle();
  },
};
</script>
<style scoped>
</style>